import { ReportReadyImagesTab } from './ReportReadyImagesTab';
import { ReportsTab } from './ReportsTab';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function RetailerReportsTab({ campaignId }: { campaignId: number; cycleId?: number | null }) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Retailer Reports</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            Review the retailer-ready evidence for this campaign, check report readiness, and generate retailer-facing
            report files from the approved images.
          </p>
        </CardContent>
      </Card>

      <ReportReadyImagesTab campaignId={campaignId} />
      <ReportsTab campaignId={campaignId} />
    </div>
  );
}
